import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioSharepointIcon } from './icon';
import { ForgePioSharepointSearchResultIcon } from './search-result-icon';

export const forgePioSharepointConfig: ThirdPartyConfig = {
	displayName: 'SharePoint by Pio',
	id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
	resourceType: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
	icon: get3PLogo(ForgePioSharepointIcon, 'ForgePioSharepoint', 'medium'),
	searchResultIcon: get3PLogo(ForgePioSharepointSearchResultIcon, 'ForgePioSharepoint', 'large'),
	integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Pdf],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
